import ApplicationSerializer from "parog-web/serializers/application";

export default class extends ApplicationSerializer {
  attrs = {
    serologieHepatiteCValue: "serologie-hepatite-c-value",
    serologieHepatiteCDate: "serologie-hepatite-c-date"
  };
}
